import { useContext } from 'react';
import { AuthContext } from './context/AuthContext.jsx';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Sidebar from './components/Sidebar.jsx';
// Public Pages
import LoginPage from './pages/public/LoginPage.jsx';
import PromotionPage from './pages/public/PromotionPage.jsx';
import EventsPage from './pages/public/EventsPage.jsx';
import CoursesPage from './pages/public/CoursesPage.jsx';
import FeesPage from './pages/public/FeesPage.jsx';
import TrainersPage from './pages/public/TrainersPage.jsx';
import AboutUsPage from './pages/public/AboutUsPage.jsx';
import ContactUsPage from './pages/public/ContactUsPage.jsx';
import TestimonialsPage from './pages/public/TestimonialsPage.jsx';
// Private Pages
import DashboardPage from './pages/private/DashboardPage.jsx';
import MemberRegistrationPage from './pages/private/MemberRegistrationPage.jsx';
import AttendanceManagementPage from './pages/private/AttendanceManagementPage.jsx';
import ReportsPage from './pages/private/ReportsPage.jsx';
import NotificationsPage from './pages/private/NotificationsPage.jsx';
import TrainerManagementPage from './pages/private/TrainerManagementPage.jsx';
import BatchManagementPage from './pages/private/BatchManagementPage.jsx';
import PaymentsPage from './pages/private/PaymentsPage.jsx';

export default App;

function PrivateRoute({ children }) {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

function App() {
  const { isAuthenticated, logout } = useContext(AuthContext);
  return (
    <div className="min-h-screen bg-gray-100 font-sans antialiased flex flex-col">
      <Header />
      <div className="container mx-auto p-4 flex flex-col md:flex-row flex-grow gap-6 mt-6">
        <Sidebar isAuthenticated={isAuthenticated} logout={logout} />
        <main className="flex-grow bg-white p-6 rounded-lg shadow-xl">
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/promotion" element={<PromotionPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/fees" element={<FeesPage />} />
            <Route path="/trainers" element={<TrainersPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />

            {/* Private Routes */}
            <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
            <Route path="/member-registration" element={<PrivateRoute><MemberRegistrationPage /></PrivateRoute>} />
            <Route path="/attendance-management" element={<PrivateRoute><AttendanceManagementPage /></PrivateRoute>} />
            <Route path="/reports" element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
            <Route path="/notifications" element={<PrivateRoute><NotificationsPage /></PrivateRoute>} />
            <Route path="/trainer-management" element={<PrivateRoute><TrainerManagementPage /></PrivateRoute>} />
            <Route path="/batch-management" element={<PrivateRoute><BatchManagementPage /></PrivateRoute>} />
            <Route path="/payments" element={<PrivateRoute><PaymentsPage /></PrivateRoute>} />

            {/* Redirects */}
            <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
            <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
          </Routes>
        </main>
      </div>
      <Footer />
    </div>
  );
}
